import { Box, Button, styled, Typography } from "@mui/material";
import BuyButton from "./BuyButton";
import { ProductDto } from "../../services/generated.schemas";
import { useDispatch } from "react-redux";
import { addItem } from "../../store/cartSlice";

type CheckoutButtonsProps = {
  selectedProduct: ProductDto | undefined;
  selectedVariant: number;
  collectionTitle: string;
};

const Wrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "clamp(12px, 2vw, 20px)",
  padding: "clamp(2rem, 4vw, 4rem)",
});

const AddToCartButton = styled(Button)({
  color: "#000",
  padding: "clamp(6px, 1vh, 10px) clamp(12px, 3vw, 24px)",
  fontSize: "clamp(0.7rem, 1.5vw, 1rem)",
  minWidth: "clamp(100px, 40%, 200px)",
  "&:hover": {
    borderColor: "#BEBEBE",
    backgroundColor: "#f5f5f5",
  },
  textDecoration: "none",
  transition: "color 0.3s ease",
  border: "1px solid #BEBEBE",
  borderRadius: "10rem",
  textTransform: "capitalize",
  borderWidth: "1px",
});

const PriceTypography = styled(Typography)({
  fontSize: "clamp(0.8rem, 2vw, 1.4rem)",
  marginLeft: "clamp(4px, 1vw, 12px)",
  minWidth: "40px",
  fontWeight: "400",
});

const CheckoutButtons = ({
  selectedProduct,
  selectedVariant,
  collectionTitle,
}: CheckoutButtonsProps) => {
  const dispatch = useDispatch();

  const handleAddToCart = (item: ProductDto | undefined) => {
    if (item) {
      dispatch(
        addItem({
          product: item,
          variantIdx: selectedVariant,
          collectionTitle,
          quantity: 1,
        }),
      );
    }
  };

  return (
    <Wrapper>
      {selectedProduct && (
        <BuyButton
          items={[
            {
              product: selectedProduct,
              variantIdx: selectedVariant,
              collectionTitle,
              quantity: 1,
            },
          ]}
        />
      )}

      <AddToCartButton
        variant="outlined"
        onClick={() => handleAddToCart(selectedProduct)}
      >
        Add To Cart
      </AddToCartButton>

      <PriceTypography variant="h5" fontWeight="regular">
        {selectedProduct?.variants[selectedVariant].price}₪
      </PriceTypography>
    </Wrapper>
  );
};

export default CheckoutButtons;
